import { Mail, MapPin } from "lucide-react";
import { RevealLines } from "./Motion";
import ContactForm from "./ContactForm";

export default function Contact() {
  return (
    <section id="kontakt" className="bg-ink py-24 md:py-32">
      <div className="mx-auto grid max-w-[1360px] grid-cols-1 gap-12 px-5 md:px-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="mb-6 font-mono text-xs uppercase tracking-[0.2em] text-[#7c86ff]">/ Kontakt</p>
          <h2 className="font-display text-5xl leading-[0.9] text-white sm:text-6xl md:text-7xl">
            <RevealLines lines={["Lass uns dein"]} />
            <span className="block text-[#7c86ff]">
              <RevealLines lines={["Projekt starten."]} delay={0.12} />
            </span>
          </h2>
          <p className="mt-7 max-w-md text-lg text-[#b3ada2]">
            Erzähl uns von deinem Vorhaben: kostenloses Erstgespräch, ehrliche Einschätzung,
            klares Angebot. Antwort innerhalb von 24 Stunden.
          </p>

          <div className="mt-10 space-y-4">
            <a
              href="mailto:info.iym24@gmail.com"
              data-testid="contact-email-link"
              className="flex items-center gap-3 text-[#e7e2d8] transition-colors hover:text-white"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15">
                <Mail className="h-4 w-4" />
              </span>
              info.iym24@gmail.com
            </a>
            <div className="flex items-center gap-3 text-[#e7e2d8]">
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15">
                <MapPin className="h-4 w-4" />
              </span>
              Dresden · Deutschland
            </div>
          </div>
        </div>

        <ContactForm className="rounded-2xl bg-white p-6 md:p-8" />
      </div>
    </section>
  );
}
